import React from "react"
import { DatePicker, TimePrecision, DateInput } from "@blueprintjs/datetime";
import InputLabel from '@material-ui/core/InputLabel';

import { TextFieldHelper } from './Fields';

import moment from 'moment'

export default class DatePickerContainer extends React.Component {

    state = {
        value: null
    }

    onChange = (date) => {
        this.props.onChange(date)
    }

    formatDate = (date) => {
        var date = moment(date).format("DD.MM.YYYY")
        return date
    }

    parseDate = (str) => {
        var date = moment(str, "DD.MM.YYYY").toDate()
        return date
    }

    value = () => {
        return this.props.value
    }

    handleChange = name => event => {
        var val = (event.target.value.replace(" ", "")).replace(/\./g, "")
        if ((val+"").length > 7) { 
            var newDate = new Date(Date.UTC(parseInt(val[4]+val[5]+val[6]+val[7]), parseInt(val[2]+val[3])-1, parseInt(val[0]+val[1]), 0, 0, 0, 0))
            this.props.onChange(newDate)
            return
        }
        this.props.onChange(val) 
    }

    render() {

        var {
            value, onChange, label, dateInput, name, disabled
        } = this.props

        if ((value+"").replace(" ", "").replace(/\./g, "").length > 7 && value !== undefined) {
            value = this.formatDate(value)
        }

        return <TextFieldHelper disabled={disabled} placeholder={"Datum: " + label} value={value} onChange={this.handleChange(name)} label={label} />

    }

}

/*

        if(dateInput!==undefined) {
            return (
                <div className="datePickerContainer">
                    <InputLabel shrink>{label}</InputLabel>
                    <DateInput
                        minDate={moment().subtract(100, "years").toDate()}
                        maxDate={moment().add(10, "years").toDate()}
                        formatDate={this.formatDate}
                        onChange={this.onChange}
                        parseDate={this.parseDate}
                        placeholder={label}
                        value={this.props.value && new Date(this.props.value)}
                        invalidDateMessage="Kein Datum gewählt"
                    />
                </div>
            )
        }

        return (
            <DatePicker
                minDate={moment().subtract(100, "years").toDate()}
                maxDate={moment().add(10, "years").toDate()}
                formatDate={this.formatDate}
                onChange={onChange}
                parseDate={this.parseDate}
                placeholder={label}
                value={this.value}
            />
        )


<DatePicker
                keyboard
                fullWidth
                label={label}
                format="DD.MM.YYYY"
                placeholder="16.05.1989"
                mask={pickerValue => (pickerValue ? [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/] : [])}
                value={pickerValue}
                keyboardIcon={<CalendarIcon />}
                onChange={onChange}
                disableOpenOnEnter
                animateYearScrolling={false}
            />

*/


// WEBPACK FOOTER //
// ./src/Components/DatePickerContainer.js